export default __webpack_public_path__ + "static/media/instant-rebate-ico.5f9e30d2.svg";